<div class="header">
  <h1>{{ statusMessage }}</h1>
  <mat-chip-list *ngIf="statusMessage">
    <mat-chip color="primary" selected class="count-chip">{{
      projectArray.length || 0
    }}</mat-chip>
  </mat-chip-list>
</div>
<div class="table-container">
  <div class="content">
    <div class="filter">
      <mat-form-field appearance="standard">
        <mat-label>Filter projects</mat-label>
        <input
          matInput
          (keyup)="filterProjects($event)"
          #input
          placeholder="ex. John Doe"
        />
      </mat-form-field>
    </div>

    <table
      mat-table
      [dataSource]="dataSource"
      class="table"
      matSort
      fixedLayout="true"
    >
      <ng-container matColumnDef="projectId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Project #</th>
        <td mat-cell *matCellDef="let project">
          {{ project.projectId || "n/a" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="customerName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Customer Name</th>
        <td mat-cell *matCellDef="let project">
          {{ project.customerName || "n/a" | titlecase }}
        </td>
      </ng-container>
      <ng-container matColumnDef="jobaddress">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Job Address</th>
        <td mat-cell *matCellDef="let project">
          {{ project.jobaddress || "n/a" | titlecase }}
        </td>
      </ng-container>
      <ng-container matColumnDef="contractDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Contract Date</th>
        <td mat-cell *matCellDef="let project">
          {{ project.contractDate | date : "shortDate" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="contractTotal">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Contract Total $
        </th>
        <td mat-cell *matCellDef="let project">
          {{ project.contractTotal | currency : "USD" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="projectTotal">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Project Total $
        </th>
        <td mat-cell *matCellDef="let project">
          {{ project.projectTotal | currency : "USD" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="projectName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Project Type</th>
        <td mat-cell *matCellDef="let project">
          {{ project.projectName || "n/a" | titlecase }}
        </td>
      </ng-container>
      <ng-container matColumnDef="foreman">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Foreman</th>
        <td mat-cell *matCellDef="let project">
          {{ project.foreman || "n/a" | titlecase }}
        </td>
      </ng-container>
      <ng-container matColumnDef="scheduledDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Scheduled Date
        </th>
        <td mat-cell *matCellDef="let project">
          <ng-container *ngIf="project.scheduledDate">
            {{ project.scheduledDate | date : "shortDate" }}
          </ng-container>
          <ng-container *ngIf="!project.scheduledDate">
            {{ "n/a" }}
          </ng-container>
        </td>
      </ng-container>
      <ng-container matColumnDef="confirmedDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Confirmed Date
        </th>
        <td mat-cell *matCellDef="let project">
          <ng-container *ngIf="project.confirmedDate">
            {{ project.confirmedDate | date : "shortDate" }}
          </ng-container>
          <ng-container *ngIf="!project.confirmedDate">
            {{ "n/a" }}
          </ng-container>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>

      <tr class="mat-row" *matNoDataRow [ngStyle]="{ 'text-align': 'center' }">
        <td class="mat-cell" [attr.colspan]="displayedColumns.length">
          No matching results
        </td>
      </tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        (click)="goToProject(row)"
      ></tr>
    </table>

    <div *ngIf="isLoading" class="spinner">
      <mat-spinner color="accent" mode="indeterminate"></mat-spinner>
    </div>

    <mat-paginator
      [pageSize]="100"
      [pageSizeOptions]="[10, 50, 100, 150, 500]"
      showFirstLastButtons
    ></mat-paginator>
  </div>
</div>
